import "./styles.scss";

import * as Material from "@mui/material";
import { AddRounded, SettingsRounded, MovieCreationRounded, SlowMotionVideoRounded } from "@mui/icons-material";

import { Button } from "@fragments";


export default function ActionsRow({
    handleCreatePlaylist,
    handleCreateSingleLesson,
    handleConfigureSession
}) {
    return (
        <div className="actions-row mb-6">
            <Button
                color="overlay"
                size="large"
                startIcon={<MovieCreationRounded />}
                endIcon={<AddRounded />}
                text="Criar conteúdo avulso"
                onClick={handleCreateSingleLesson}
            />
            
            <Button
                color="overlay"
                size="large"
                startIcon={<SlowMotionVideoRounded />}
                endIcon={<AddRounded />}
                text="Adicionar playlist"
                onClick={handleCreatePlaylist}
            />

            <Material.Divider
                orientation="vertical"
                flexItem
                className="ml-2 mr-2"
            />

            <Button
                color="overlay"
                size="large"
                endIcon={<SettingsRounded />}
                text="Configurar sessão"
                onClick={handleConfigureSession}
            />
        </div>
    );
}

